import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'forward' } )
export class ForwardPipe implements PipeTransform {

    transform( pIsForwarded: boolean ): string {
        if ( pIsForwarded != null ) {
            return pIsForwarded === true ? 'Forwarded' : 'Pending';
        }
    }
}
